import { Link } from "react-router-dom";

const HERO_IMAGE = "/img/living-room.png";

const SWITCHBOARD_IMG = "/img/switchboard.jpeg";

// Click regions sized over each product in the image (% of image itself).
const REGIONS = [
  { id: "leds",  label: "LED LIGHTS",      to: "/category/leds",  top: "5%",  left: "0%",  width: "62%", height: "26%" },
  { id: "fans",  label: "FANS",            to: "/category/fans",  top: "4%",  left: "63%", width: "37%", height: "33%" },
  { id: "mcb",   label: "MCBS AND BOXES",  to: "/category/mcb",   top: "37%", left: "2%",  width: "22%", height: "33%" },
  { id: "wires", label: "WIRES",           to: "/category/wires", top: "73%", left: "55%", width: "38%", height: "20%" },
];

export default function InteractiveHouse({ rounded = true }) {
  return (
    <div
      className={`relative w-full overflow-hidden bg-white ${
        rounded ? "rounded-3xl shadow-xl border border-slate-200" : ""
      }`}
    >
      {/* Natural aspect — no cropping — so hotspot % map 1:1 to image content */}
      <img
        src={HERO_IMAGE}
        alt="Huge modern Indian living room with electrical fittings"
        className="block w-full h-auto"
        data-testid="hero-house-image"
        draggable={false}
      />

      {/* Switchboard overlaid on the clean centre wall — 75% of previous size */}
      <Link
        to="/category/switches"
        className="absolute group cursor-pointer"
        style={{
          top: "58%",
          left: "47%",
          width: "9%",
          transform: "translate(-50%, -50%)",
        }}
        data-testid="hotspot-switches"
        aria-label="Switchboard"
      >
        <img
          src={SWITCHBOARD_IMG}
          alt="Premium brass-handle switchboard"
          className="w-full h-auto rounded-[3px] shadow-[0_8px_22px_rgba(0,0,0,0.22)] ring-1 ring-black/15 transition-transform duration-300 group-hover:scale-[1.06]"
          draggable={false}
        />
        <span className="absolute left-1/2 -translate-x-1/2 -bottom-9 px-3 py-1.5 rounded-full bg-slate-900 text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg">
          SWITCHES →
        </span>
      </Link>

      {REGIONS.map((r) => (
        <Link
          key={r.id}
          to={r.to}
          className="absolute group cursor-pointer"
          style={{ top: r.top, left: r.left, width: r.width, height: r.height }}
          data-testid={`hotspot-${r.id}`}
          aria-label={r.label}
        >
          <span className="absolute left-1/2 -translate-x-1/2 -bottom-9 px-3 py-1.5 rounded-full bg-slate-900 text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg z-20">
            {r.label} →
          </span>
        </Link>
      ))}
    </div>
  );
}
